export const NO_DATA_PLACEHOLDER = '-';

export const PERCENTAGE_SYMBOL = '%';
export const PLUS_SIGN = '+';
export const DATE_RANGE_SEPARATOR = ' – ';
export const MIDDLE_DOT_SEPARATOR = ' · ';

export const RANGE_INPUT_OMITTED_CHARACTERS = ['e', 'E', PLUS_SIGN, '-'];

export const OFFICE_APPS_EMBED_URL =
  'https://view.officeapps.live.com/op/embed.aspx';
export const GOOGLE_DOCS_VIEWER_URL = 'https://docs.google.com/viewer';

export const VENDORS_TIME_FORMAT = 'h:mm a';
export const VENDORS_DATE_FORMAT = 'MMM d,';
export const VENDORS_DATETIME_FORMAT = `${VENDORS_DATE_FORMAT} ${VENDORS_TIME_FORMAT}`;
export const DOCUMENT_EMPTY_DATE_FORMAT = '--/--/----';

export const ICON_CIRCLE_STYLES =
  'border-primary border-surface-subtle bg-neutral-color rounded-full border-10 border-solid';
